import { DisabledPrompt, useModel, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import TableView, { TableRowView } from "compid/shared/views/TableView";
import UIButton from "compid/ui/UIButton";
import { getDefault, getWorkflowSteps } from "compid/workflows/PaymentInquiryWorkflow";
import { Profile } from "model";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function PaymentInquiryConfirmationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for PaymentInquiryConfirmationPage
 */

export default function PaymentInquiryConfirmationPage(props) {
  const navigate = useRoute();
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
  const workflowState = workflowStep.getStepState;
  const paymentInquiry = workflowStep.read("paymentInquiry");
  const payment = paymentInquiry.payment;
  // All confirmation numbers for payments will be the same for now.
  const confirmationNumber = "TN2RH-1LNHX";
  const account = payment.from;
  const biller = payment.to;
  var lateFeesAccessed =  paymentInquiry.lateFeesAccessed;
  lateFeesAccessed = workflowState.userSetLateFeesAccessed ? lateFeesAccessed : undefined;
  const paymentArriveByDate = payment.date.format('M d');
  const paymentWithdrawByDate = payment.date.format('M d');
  const lateFeeWaivedMessage = paymentInquiry.billerWaivedLateFeeCharge ? "[The late fees were waived.]" : "";
  const financeChargesWaivedMessage = paymentInquiry.billerWaivedFinanceCharges ? "[The finance charges were waived.]" : "";
  const reason = paymentInquiry.reason.charAt(0).toUpperCase() + paymentInquiry.reason.slice(1);
  const model = useModel();
  const profile = Profile.init(model.profile);
  const contactName = paymentInquiry.contactName === "" ? profile.name : paymentInquiry.contactName;
  const phone = paymentInquiry.phoneNumber === "" ? profile.phone : paymentInquiry.phoneNumber;

  const fiName = props.fiName ?? "[fiName]";
  const receiptDate = props.receiptDate ?? "[receiptDate]";
  const withdrawnDate = props.withdrawnDate ?? "[withdrawnDate]";
  const accountName = props.accountName ?? "[accountName]";
  const accountNumber = props.accountNumber ?? "[accountNumber]";
  const paymentAmount = props.paymentAmount ?? "[paymentAmount]";
  //const reason = props.reason ?? "[reason]";
  const personName = props.personName ?? "[personName]";
  const phoneNumber = props.phoneNumber ?? "[phoneNumber]";
  const date = props.date ?? "[date]";
  const additionalComments = props.additionalComments ?? "[additionalComments]";

  const done = () => navigate(-1);

  return(
    <PageView className="payment-inquiry-confirmation-page">
      <p className="page-sub-header semi-bold-text">PAYMENT INQUIRY CONFIRMATION</p>
      

      <PageLayoutContainer>
        <CenterColumnContainer>
            {/* BillerView needs hook up - Had to comment it out as it caused issues on the page  */}
            <BillerView
           biller={ biller } 
           paymentInfo={
            <BillerPaymentView 
                amount={ payment.amount }
                status={ payment.status }
                date={ payment.formatDate }
                showAutopay={ payment.hasRelatedAutopay }
                description={<>Last<span className="show-on-desktop payment">Payment</span><span className="show-on-mobile payment">pmt</span></>} />
           }
           />

            <div className="inset-container">
              <div className="flex-container flex-vertical all-center form-row icon-container">
                  <SVGAsset id="CheckmarkIcon" className="green-icon" />
                  <p className="semi-bold-text text-center">Your payment inquiry has been successfully sent to customer service. </p>
              </div>

              <p className="response-text text-center">We typically respond to customer inquiries in three to four business days. Please see your messages for a customer service response.</p>

              <div className="border-top">
                <p>Your check was mailed to { biller.name } for receipt by { paymentArriveByDate }. Money was withdrawn from your account on { paymentWithdrawByDate }. The payment was applied on { paymentWithdrawByDate }.</p>
                
                <TableView>
                  <TableRowView label="Pay from" data={`${ account.name } ${ account.number }`} />
                  <TableRowView label="Amount" data={ `${payment.amount.format() }`} />
                  <TableRowView label="Confirmation" data={ `${ confirmationNumber }`} />
                </TableView>
              </div>

              <div className="border-top">
                <p>The following information was sent to customer service:</p>
                
                <TableView>
                  <TableRowView label="Reason" data={ reason } />
                  { paymentInquiry.lateFeesAccessed &&
                    <TableRowView label="Late fees" data={`Late fees in the amount of ${ paymentInquiry.lateFeesAmount.format() }  were imposed. ${ lateFeeWaivedMessage }`} />
                  }
                  { paymentInquiry.financeChargesAssessed &&
                    <TableRowView label="Finance charges" data={`Finance charges in the amount of ${ paymentInquiry.financeChargesAmount.format() } were imposed. ${ financeChargesWaivedMessage }`} />
                  }
                </TableView>
              </div>

              <div className="border-top">
                <p>I contacted the following person at { biller.name }:</p>
                
                <TableView>
                  <TableRowView label="Name" data={ contactName } />
                  <TableRowView label="Phone" data={ phone } />
                  <TableRowView label="Date" data={ paymentInquiry.contactDate.format('M d') } />
                  <TableRowView label="Additional comments" data={ paymentInquiry.additionalComments } />
                </TableView>
              </div>

              <ButtonContainer>
                <DisabledPrompt>
                  <UIButton className="secondary-button">Print</UIButton>
                </DisabledPrompt>
                <UIButton className="primary-button" onClick={ done }>Done</UIButton>
              </ButtonContainer>
            </div>
          </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  );
}